import { Bill } from "../types/Bill";
import { getData, postData } from "./apiService";


export const getBills = async (host_id: string): Promise<Bill[]> =>{
    try {
      const response = await getData(`/billing`, { host_id : host_id});
      return response.data as Bill[];
    } catch (error) {
      console.error('Failed to fetch bills:', error);
      return [];
    }
  };


  export const payBillWithStripe = async (billId: string): Promise<string> => {
    try {
      const response = await postData(`/billing/stripe/checkout-session`, { billId: billId });
  
      const data = await response;
  
      if (data.url) {
        return data.url;
      } else {
        console.error("Stripe session creation failed:", data);
      }
      throw Error;
    } catch (error) {
      console.error("Error during Stripe checkout:", error);
      throw Error;
    }
  };

  export const payBillWithPayPal = async (billId: string, userId: string): Promise<void> => {
    try {
      const response = await postData(`/billing/paypal/create-order`, { billId: billId, userId: userId });
  
      const data = await response.json();
  
      if (data.approval_url) {
        window.location.href = data.approval_url; // Redirect to PayPal
      } else {
        console.error("PayPal session creation failed:", data);
      }
    } catch (error) {
      console.error("Error during PayPal checkout:", error);
    }
  };

  export const getCalculateEventCost = async (count: number, hasMedia: boolean): Promise<number> => {
    try {
      const response = await getData(`/get-cost`, { count: count, has_media: hasMedia });
  
      return response.data.estimated_total as number;
    } catch (error) {
      console.error("Could not calculate cost at this time.");
      throw error;
    }
  }
  